<ul class="list-group list-group-flush" *ngIf="router.url === '/profile'">
    <p>
        <strong>{{ 'nombre' | translate}}:</strong> {{user.nombre}} {{user.apellido1}} {{user.apellido2}}<br />
        <strong>{{ 'email' | translate}}: </strong> {{user.email}}
    </p>
    <div class="form-row">
        <div class="form-group col">
            <button kendoButton (click)="onClickEditar()"
                class="btn mr-1  btn-primary">{{ 'actualizar' | translate}}</button>
        </div>
    </div>
</ul>
<router-outlet></router-outlet>


